import React, { useContext } from "react";
import { EjesContext } from "../context/EjesContext";

import {
  Backdrop,
  Box,
  Button,
  Modal,
  Fade,
  Typography,
  Stack,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function FinalizarCuestionario({ idCuestionario }) {
  const { t, EnviarCuestionario, openFinalizarCuestionario, setOpenFinalizarCuestionario } = useContext(EjesContext);

  const handleClose = () => {
    setOpenFinalizarCuestionario(false);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openFinalizarCuestionario}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openFinalizarCuestionario}>
          <Box sx={style}>
            <Stack spacing={2}>
              <Typography
                id="transition-modal-title"
                variant="h6"
                sx={{fontWeight: 'bold'}}
              >
                {t("cuestion.tituloFinalizarCuestionario")}
              </Typography>
              <Typography
                id="transition-modal-description"
                textAlign={"justify"}
                sx={{ mt: 2 }}
              >
                {t("cuestion.textoFinalizarCuestionario")}
              </Typography>
            </Stack>
            <Stack
              direction={"row"}
              spacing={2}
              marginTop={3}
              justifyContent={"space-between"}
            >
              <Button onClick={handleClose} variant="contained">
                {t("cuestion.btnCancelar")}
              </Button>
                          <Button onClick={() => { EnviarCuestionario(idCuestionario) }} variant="contained">
                {t("cuestion.btnEnviar")}
              </Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default FinalizarCuestionario;
